<template>
  <footer>
    <div class="inner">
      <nav class="">
        <ul class="footerMenu">
          <li><router-link to="/about">開催概要</router-link></li>
          <li><router-link to="/t10s">東京カメラ部10選</router-link></li>
          <li><router-link to="/j100v">日本写真100景</router-link></li>
          <li><router-link to="/sponsors">協賛展示</router-link></li>
          <li><router-link to="/organizer">主催者企画</router-link></li>
          <li><router-link to="/reports">トークステージレポート</router-link></li>
          <li><router-link to="/events">イベントカレンダー</router-link></li>
          <!--
          <li><router-link to="/events/archives">イベントカレンダー</router-link></li>
          -->
        </ul>
        <ul class="footerMenuSub">
          <li><router-link to="/exhibitors">作品展示 展示者一覧</router-link></li>
          <li v-if="this.isUpdateinfoPage()"><a href="javascript:void(0);" @click="moveUp">アップデート情報</a></li>
          <li v-else><router-link to="/updateinfo">アップデート情報</router-link></li>
        </ul>
      </nav><!-- /#footerMenu -->

      <div class="footerlogo">
      <router-link to="/"><img src="/img2022/titlefooter.svg" alt="東京カメラ部2022写真展 Online Exhibition「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -" /></router-link>
      </div><!-- #footerlogo -->

      <div class="copyright">
        <a href="https://corporate.tokyocameraclub.com/corporate02.php" target="_blank">主催：東京カメラ部株式会社【会社概要】</a><br />
        記載されているブランド名、会社名、商品名、ロゴなどは各社の登録商標もしくは商標です。<br />
        Copyright &copy; Tokyo Camera Club Corp. All Rights Reserved.
      </div><!-- #copyright -->
    </div><!-- /inner-->
  </footer>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
    isUpdateinfoPage () {
      return this.$route.path === '/updateinfo'
    },
    moveUp () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped>
footer .copyright a {
  color: #fff;
}
</style>
